import React, { useContext, useEffect } from "react"
import { useCurrentUser } from "#/components/context/user/UserContext"
import { SettingsContext } from "#/pages/account"
import { useFormContext, FormTextField } from "@carrotfertility/carotene-core-x"
import { useIntl } from "react-intl"
import { useIntlValidator } from "#/utils/hooks/useIntlValidator"
import { emailValidation } from "#/utils/Regexes"
import { HttpStatusCodes } from "#/utils/HttpStatusCodes"
import { getHeap } from "#/utils/heap"
import { InviteStatusResult, PartnerInviteStatus } from "#/components/partner-access/partnerAccessTypes"

export function PartnerEmail({ inviteData = null }: { inviteData?: InviteStatusResult }): JSX.Element {
  const { personalEmail, email } = useCurrentUser()
  const { fieldErrorFromServer } = useContext(SettingsContext)
  const { setError } = useFormContext()
  const intl = useIntl()
  const intlEmailValidation = useIntlValidator(emailValidation)

  useEffect(() => {
    if (
      fieldErrorFromServer?.response?.status === HttpStatusCodes.CONFLICT &&
      fieldErrorFromServer?.message.includes("Partner email already exists")
    ) {
      setError("partnerEmail", {
        message: intl.formatMessage({ defaultMessage: "That email address is already in use" })
      })
      getHeap().track("DuplicateEmail", { EventName: "Attempted to use non-unique email" })
    }
  }, [setError, fieldErrorFromServer, intl])

  function validate(partnerEmail: string) {
    if (!partnerEmail) {
      return true
    }
    if (partnerEmail && (partnerEmail === personalEmail || partnerEmail === email)) {
      getHeap().track("DuplicateEmail", { EventName: "Attempted to use non-unique email" })
      return intl.formatMessage({ defaultMessage: "That email address is already associated with your account." })
    }

    return intlEmailValidation(partnerEmail)
  }
  return (
    <FormTextField
      label={intl.formatMessage({ defaultMessage: "Email" })}
      name="partnerEmail"
      registerOptions={{ validate }}
      disabled={inviteData?.status === PartnerInviteStatus.ACTIVE}
      type="email"
    />
  )
}
